import { useNavigate } from "react-router-dom";

import Button from "@/components/buttons/Button";
import RegisterHeader from "@/features/auth/fragments/registration-header";
import RocketImage from "@/assets/images/rocket-boy.png"

const RegisterFinishForm = () => {
    const navigate = useNavigate();

    const handleNext = () => {
        navigate("/auth/login")
    }

    return (
        <div className="space-y-12">
            <RegisterHeader 
                heading={"Welcome to ZCT Portal"}
                description={"We’re here to make your investment and licensing journey seamless."}
            />

            <form className="lg:w-3/5 mx-auto">
                <div>
                    <img 
                        src={RocketImage} 
                        alt="rocket-boy"
                        className="" 
                    />
                </div>

                <Button 
                    intent="primary" 
                    size="md" 
                    className="w-full"
                    onClick={handleNext}
                >
                    Let's Get Started
                </Button>
            </form>
        </div>
    )
}

export default RegisterFinishForm